var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageInAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53846 1H20.4615C21.8635 1 23 2.46525 23 4.27273V21.7273C23 23.5347 21.8635 25 20.4615 25H3.53846C2.13651 25 1 23.5347 1 21.7273V4.27273C1 2.46525 2.13651 1 3.53846 1Z",
    stroke: "#2D9CDB",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10C7.89543 10 7 9.10457 7 8C7 6.89543 7.89543 6 9 6C10.1046 6 11 6.89543 11 8C11 9.10457 10.1046 10 9 10Z",
    fill: "#2D9CDB",
    stroke: "#2D9CDB",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46154 18.621L14.2561 12.6213C14.5611 12.2388 14.9712 12.017 15.4024 12.0009C15.8337 11.9849 16.2535 12.176 16.5761 12.5351L23 19.6958M13.6923 25L7.16952 16.8222C6.87122 16.4475 6.47194 16.2261 6.0501 16.2016C5.62827 16.177 5.21436 16.3511 4.88966 16.6896L1 20.7566",
    stroke: "#2D9CDB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageInAttachmentIcon);
export default __webpack_public_path__ + "static/media/imageInAttachmentIcon.b5db3224ff29f00a19ab352564ae173b.svg";
export { ForwardRef as ReactComponent };